module.exports = __webpack_public_path__ + "img/horse_s_neck.1df31735.jpg";